import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer } from '@material-ui/core';
import clsx from 'clsx';
import { SlimScroll } from 'components';
import { headerHeight, sidebarWidth, sidebarWidthOnClose } from 'config/style';
import SidebarList from './SidebarList';
import { useReduxSelector } from 'store/hooks';

const Sidebar = () => {
  const [open, setOpen] = useState(false);
  const app = useReduxSelector((state) => state.app);
  const account = useReduxSelector((state) => state.account);
  const classes = makeStyles((theme) => ({
    drawer: {
      height: `calc(100vh - ${headerHeight}px)`,
      marginTop: headerHeight,
      position: 'relative',
      whiteSpace: 'nowrap',
      backgroundColor: app.env.colors?.primary || '#027EDD',
      borderRight: 'none',
    },
    drawerOpen: {
      width: sidebarWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      width: sidebarWidthOnClose,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
  }))();

  if (!(account.data.isHR || account.data.isSPV || account.data.access)) return <div />;

  return (
    <Drawer
      variant="permanent"
      className={clsx({
        [classes.drawerOpen]: open,
        [classes.drawerClose]: !open,
      })}
      classes={{
        paper: clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        }),
      }}
      open={open}
      style={{ backgroundColor: 'red' }}
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <SlimScroll>
        <SidebarList open={open} />
      </SlimScroll>
    </Drawer>
  );
};

export default Sidebar;
